import React, { useState, useCallback, useRef } from 'react';
import { Box, Paper } from '@mui/material';
import GanttToolbar from './GanttToolbar';
import GanttIntegrated from './GanttIntegrated';
import { useModularUnits } from '../hooks/useModularUnits';

export default function GanttHierarki() {
  const [search, setSearch] = useState('');
  const [selectedUnit, setSelectedUnit] = useState('ALL'); // 'ALL' for all units
  const [showActual, setShowActual] = useState(true);
  const apiRef = useRef(null);
  const { units: modularUnits, refresh: refreshUnits } = useModularUnits();
  // const [unitOptions, setUnitOptions] = useState([]);

  // Toolbar handlers mapped to dhtmlx API
  const onCollapseAll = useCallback(() => apiRef.current?.collapseAll?.(), []);
  const onExpandAll = useCallback(() => apiRef.current?.expandAll?.(), []);
  const onViewLevel = useCallback((level) => {
    if (level === 'project') apiRef.current?.collapseToProject?.();
    if (level === 'category') apiRef.current?.collapseToCategory?.();
  }, []);
  const onAdd = useCallback(() => apiRef.current?.addTask?.(), []);
  const onExportImage = useCallback(async () => {
    try {
      await apiRef.current?.executeExportInternal?.();
    } catch (_) {}
  }, []);
  const onRefresh = useCallback(() => {
    apiRef.current?.refresh?.();
    refreshUnits?.();
  }, [refreshUnits]);

  return (
    <>
      <Paper elevation={1} sx={{ p: 1.5, border: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column' }}>
        <GanttToolbar
        search={search}
        onSearchChange={setSearch}
        onCollapseAll={onCollapseAll}
        onExpandAll={onExpandAll}
        onViewLevel={onViewLevel}
        onRefresh={onRefresh}
        onAdd={onAdd}
        onExportImage={onExportImage}
        modularUnits={modularUnits}
        selectedUnit={selectedUnit}
        onUnitChange={setSelectedUnit}
        showActual={showActual}
        onToggleShowActual={setShowActual}
        />

        <Box sx={{ minWidth: 0 }}>
          <GanttIntegrated
            searchText={search}
            unitFilterId={selectedUnit === 'ALL' ? null : selectedUnit}
            showActual={showActual}
            onReady={(api) => { apiRef.current = api; }}
          />
        </Box>

      </Paper>
    </>
  );
}
